export interface Country {
  iso: string
  name: string
}

export function toCountriesName(
  isos: string[],
  countries: Country[]
): string[] {
  return isos.map((iso) => toCountryName(iso, countries))
}

export function toCountryName(iso: string, countries: Country[]): string {
  return countries.find((c) => c.iso === iso)?.name ?? iso
}

export function toCountryCodes(
  names: string[],
  countries: Country[]
): string[] {
  return names.map((name) => toCountryCode(name, countries))
}

export function toCountryCode(name: string, countries: Country[]): string {
  return countries.find((c) => c.name === name)?.iso ?? name
}
